const remainingBalanceAsFloatReducer = (state = 0.00, action) => {
	switch(action.type){
	case 'SETFLOAT':	
		return action.payload;
	default:
		return state;
	}
}

export default remainingBalanceAsFloatReducer;